import { useEffect } from "react";
import { MixPanel, TrackAction } from "lib/mixpanel";

export const useTrackMixpanel = (action: TrackAction, data?: object) => {
  useEffect(() => {
    MixPanel.track(action, data);
  }, []);
};
